let currentId = 0;

class Accordion {
    constructor(element) {
        this.element = element;
        if(!this.element.hasAttribute('id')) {
            this.element.setAttribute('id', `cm-accordion-${++currentId}`);
        }
        this.multiple = this.element.dataset.multiple;
        this.collapsible = this.element.dataset.collapsible;
        this.initialOpen = this.element.dataset.initialOpen;
        this.update();
    }

    update() {
        const toggles = document.querySelectorAll(`#${this.element.id} > .cm-accordion__header .cm-accordion__button`);
        const contentAreas = document.querySelectorAll(`#${this.element.id} > .cm-accordion__content`);

        this.openFirstElementInitially(toggles);

        toggles.forEach((toggle, i) => {
            toggle.setAttribute('id', `${this.element.id}button-${i}`);
            toggle.setAttribute('aria-controls', `${this.element.id}content-${i}`);
            contentAreas[i].setAttribute('id', `${this.element.id}-content-${i}`);
            contentAreas[i].setAttribute('aria-labelledby', `${this.element.id}-button-${i}`);

            toggle.addEventListener('click', () => {
                this.toggleHandler(toggle);
            });
        });
    }

    toggleHandler(toggle) {
        if (toggle.classList.contains('is-active')) {
            this.close(toggle);
        } else {
            this.open(toggle);
            this.closeAllOthers(toggle);
        }
    }

    open(toggle) {
        const contentContainer = toggle.parentNode.parentNode.nextElementSibling;

        toggle.classList.add('is-active');
        toggle.setAttribute('aria-expanded', 'true');
        this.element.classList.add('is-open');
        contentContainer.classList.add('is-expanded');
        const expandedAccordion = document.querySelector('.is-expanded');
        function isElementInViewPort(element) {
            const rect = element.getBoundingClientRect();
            return (rect.top >= 0 && rect.top >= -element.offsetHeight);
        }
        if (!isElementInViewPort(expandedAccordion)) {
            expandedAccordion.scrollIntoView({behavior: 'smooth'});
        }
    }

    close(toggle) {
        const contentContainer = toggle.parentNode.parentNode.nextElementSibling;

        // don't close if at least one element has to stay open
        if (this.collapsible === 'false'
            && this.element.querySelectorAll(`#${this.element.id} > .cm-accordion__header .cm-accordion__button.is-active`).length === 1) {
            return false;
        }

        toggle.classList.remove('is-active');
        toggle.setAttribute('aria-expanded', 'false');
        contentContainer.classList.remove('is-expanded');
    }

    closeAllOthers(toggle) {
        if (this.multiple === 'false') {
            this.element.querySelectorAll(`#${this.element.id} > .cm-accordion__header .cm-accordion__button.is-active`).forEach((activeToggle) => {
                if (activeToggle !== toggle) {
                    this.close(activeToggle);
                }
            });
        }
    }

    openFirstElementInitially(toggle) {
        if (this.initialOpen === 'true') {
            this.open(toggle[0]);
        }
    }
}

const accordions = document.querySelectorAll('.js-cm-accordion-element');

if (accordions) {
    accordions.forEach(element => new Accordion(element));
}

document.querySelector('.c-social-share').remove();
